<template>
  <div class="basic-block block-banner-another" :style="styles">
    <div class="content-wrap">
      <div class="block-banner-another__inner">
        <div class="block-banner-another__headline">姉妹サイトのご紹介</div>
        <div class="block-banner-another__box">
          <a href="https://uranai-salon.jp/salons/13/detail?utm_source=uranaitv&utm_medium=banner&utm_campaign=kurenotori" class="block-banner-another__link" @click.prevent="link">
            <img src="/static/img/banner/playlist_bnr_444_basecamp20221027.png" alt="" class="block-banner-another__banner">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockBannerAnother',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: {
      type: Number,
      require: true,
    },
    gaLabel: {
      type: String,
      default: '',
    },
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    link (e) {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-induction-button`,
        'event_label': this.gaLabel,
      })
      window.open(this.$handoverParams(e.currentTarget.href), '_blank');
      //location.href = this.$handoverParams(e.currentTarget.href)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-banner-another {
  padding: 40px 0 0;
  background: #fff;
  &__inner {
    padding: 0 20px;
  }
  &__img {
    max-width: 100%;
    vertical-align: middle;
    margin: 0 auto 12px;
  }
  &__headline {
    font-weight: bold;
    font-size: 12px;
    line-height: 10px;
    text-align: center;
    background:  #fff;
    color: $l_col_keycolor;
    margin: 0 auto 16px;
    padding: 7px 0;
    border:1px solid $l_col_keycolor;
    width:320px;
  }
  &__box {
    background: #fff;
    //border: 1px solid $l_col_keycolor;;
    //border-radius: 10px;
    padding: 0 0 60px;
  }
  &__link {

  }
  &__banner {
    display: block;
    //max-width: 335px;
    width: 320px;
    margin: 0 auto 16px;
    padding: 4px;
    border: 1px solid $l_col_keycolor;
  }
  &__text {
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockBannerAnother.vue